/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import { challengeV5Schema } from '../getPublicChallengeBySlugV5/get-public-challenge-by-slug-v5-response';

export const challengeV6Schema = challengeV5Schema.extend({
  webVideoUrl: z.string().nullable().default(null),
  webVideoPosterUrl: z.string().nullable().default(null),
  webVideoWidth: z.number().nullable().default(null),
  webVideoHeight: z.number().nullable().default(null),
  webVideoDurationMs: z.number().nullable().default(null),
});

export type IChallengeV6 = z.infer<typeof challengeV6Schema>;

export const getPublicChallengeBySlugV6ResponseSchema = createApiResponseSchema(
  challengeV6Schema,
) as z.ZodSchema<IAPI<IChallengeV6>>;

export type IGetPublicChallengeBySlugV6Response = IAPI<IChallengeV6>;
